import Vue from 'vue'
import DownLoadingVue from './Main.vue'
const DownLoadingConstructor = Vue.extend(DownLoadingVue)
let instance
instance = new DownLoadingConstructor({
  el: document.createElement('div'),
})
const Downloading = (options, callback) => {
  document.getElementById('app').appendChild(instance.$el)
  instance.visible = true
}
Downloading.setProgress = val => {
  instance.progress = val
}
Downloading.close = val => {
  instance.visible = false
}
export default Downloading
